import { Box, Typography } from '@mui/material';
import React from 'react';

const ImageGallery = ({ images = [], name, handleOpen = () => {} }) => {
    if (!Array.isArray(images) || images?.length <= 0) return null;

    const renderImage = (src, index, { showExtra = false, extraCount = 0, sx = {} } = {}) => (
        <Box
            key={`${src}-${index}`}
            sx={{
                position: 'relative',
                width: '100%',
                aspectRatio: '16 / 9',
                borderRadius: '8px',
                overflow: 'hidden',
                cursor: 'pointer',
                ...sx,
            }}
            onClick={() => handleOpen(index)}
        >
            <Box
                component="img"
                src={src}
                alt={`${name}-image-${index}`}
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    display: 'block',
                    borderRadius: '8px',
                }}
            />

            {showExtra && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,.45)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>{`+${extraCount}`}</Typography>
                </Box>
            )}
        </Box>
    );

    if (images.length === 1) {
        return <Box sx={{ width: '100%' }}>{renderImage(images[0], 0)}</Box>;
    }

    if (images.length === 2) {
        return <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>{images.slaice(0, 2).map((src, i) => renderImage(src, i))}</Box>;
    }

    const extraCount = images.length - 3;

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateColumns: '2fr 1fr',
                alignItems: 'stretch',
            }}
        >
            {renderImage(images[0], 0, { sx: { height: '100%' } })}

            <Box sx={{ display: 'grid', gap: 1, gridTemplateRows: '1fr 1fr' }}>
                {renderImage(images[1], 1)}

                {renderImage(images[2], 2, {
                    showExtra: extraCount > 0,
                    extraCount,
                })}
            </Box>
        </Box>
    );
};

export default ImageGallery;
